import { useRef, useEffect, useCallback } from 'react';

// This exists to remove the issues encountered with non-memorised functions
// Previously, using setTimeout on a callback function would remake the function and lose its ref in the component
// Therefore it would run everytime, as the timeout would be cleared
// This saves the function in a callback
// And the timeout is never lost, so the throttling happens correctly
const useThrottle = (cb, delay, deps = []) => {
  const cbRef = useRef(cb);
  const timeoutRef = useRef();
  // use mutable ref to make useCallback/throttle not depend on `cb` dep
  useEffect(() => { cbRef.current = cb; }, [cb]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    timeoutRef.current = setTimeout(() => {
      if (cbRef.current) {
        cbRef.current(...args);
      }
      timeoutRef.current = null;
    }, delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps]);
};

export default useThrottle;
